"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const shallow_1 = require("zustand/shallow");
const appConstants_1 = require("../../../../constants/appConstants");
const companyQuery_1 = require("../../../../queries/companyQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const simpleHeader_1 = __importDefault(require("../../../organisms/header/simpleHeader"));
const overview_1 = __importDefault(require("../../../templates/companySettings/overview"));
const differenceBy = (arr1, arr2, iteratee) => {
    return arr1?.filter(c => !arr2?.map(iteratee).includes(iteratee(c))) || [];
};
const CompanySettingsOverviewPage = () => {
    const { setCompanyFeatures, setCompanyProperty, setHeaderName, setTeamOwners, company, companySyncState, setCompanySyncState, } = (0, zustandStore_1.useZustand)((0, shallow_1.useShallow)(state => ({
        setCompanyFeatures: state.setCompanyFeatures,
        setCompanyProperty: state.setCompanyProperty,
        setHeaderName: state.setHeaderName,
        setTeamOwners: state.setTeamOwners,
        company: state.company,
        companySyncState: state.company.companySyncState,
        setCompanySyncState: state.setCompanySyncState,
    })));
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: companyFeaturesData } = (0, react_query_1.useQuery)({
        ...companyQuery_1.companyFeaturesQuery,
        initialData: initialData.companyFeatures,
    });
    const { data: companyPropertiesData } = (0, react_query_1.useQuery)({
        ...(0, companyQuery_1.companyPropertiesQuery)(initialData.user.companyAccountId, appConstants_1.companyPropertiesConstants),
        initialData: initialData.companyProperties,
    });
    const { data: userData } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData.user,
    });
    const { data: companyAdminUsers } = (0, react_query_1.useQuery)({
        ...(0, userQuery_1.getUsersByRoleId)(appConstants_1.overviewConstants.COMPANY_ADMIN),
        initialData: initialData.companyAdmins,
    });
    const { data: teamAdminUsers } = (0, react_query_1.useQuery)({
        ...(0, userQuery_1.getUsersByRoleId)(appConstants_1.overviewConstants.TEAM_ADMIN),
        initialData: initialData.companyAdmins,
    });
    const updatedTeamOwners = (0, react_1.useMemo)(() => {
        return differenceBy(teamAdminUsers?.users, companyAdminUsers?.users, ({ userId }) => userId);
    }, [companyAdminUsers, teamAdminUsers]);
    (0, react_1.useEffect)(() => {
        setTeamOwners(updatedTeamOwners);
    }, [companyAdminUsers, setTeamOwners, teamAdminUsers, updatedTeamOwners]);
    (0, react_1.useEffect)(() => {
        const { companyName, propertyValue, features, properties } = company;
        const syncState = {
            companyName,
            propertyValue,
            features,
            properties,
        };
        setCompanySyncState(syncState);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setCompanySyncState]);
    (0, react_1.useEffect)(() => {
        if (companyPropertiesData) {
            for (const [propertyKey, value] of Object.entries(companyPropertiesData)) {
                setCompanyProperty({
                    key: propertyKey,
                    value: propertyKey === 'showactivity' ? value.toString() : value,
                });
            }
        }
    }, [companyPropertiesData, setCompanyProperty]);
    (0, react_1.useEffect)(() => {
        if (companyFeaturesData) {
            setCompanyFeatures(companyFeaturesData);
        }
    }, [companyFeaturesData, setCompanyFeatures]);
    (0, react_1.useEffect)(() => {
        if (userData) {
            setHeaderName(companySyncState.companyName || userData.companyName || '');
        }
    }, [companySyncState.companyName, userData]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(simpleHeader_1.default, {}), (0, jsx_runtime_1.jsx)(overview_1.default, {})] }));
};
exports.default = CompanySettingsOverviewPage;
